module.exports = __webpack_public_path__ + "img/list.757d3bea.svg";